<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     生产管理--生产进度
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="mes-progress header-padding" v-loading="exporting" element-loading-text="拼命导出中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.8)">

    <f-page-header />

    <div class="filter-container">

      <div class="filter-box">
        <span class="filter-item">
          <f-radio-btn-group v-model="query.status" :groups="radios" type="arrow" @change="fetchData(1)" />
        </span>

        <span class="filter-item lg">
          <f-date-range-picker v-model="query.dispatch_time" :shortcuts="[ 0, 1, 2, -7, -30, -90 ]" :placeholder="['下发开始','下发结束']" @change="fetchData(1)" />
        </span>

        <span class="filter-item lg">
          <mes-num-selector v-model="query.mfgid" placeholder="选择制号" @change="fetchData(1)" />
        </span>

        <span class="filter-item sm">
          <pp-station-selector v-model="query.stationid" placeholder="选择工位" @change="fetchData(1)" />
        </span>

        <span class="filter-item sm">
          <f-search-input v-model="query.keyword" @change="fetchData(1)" />
        </span>

      </div>
    </div>

    <el-card v-loading="loading" class="table-card" shadow="never">
      <el-table ref="listTable" :data="list" style="width: 100%" size="medium" class="padding-small"
        @selection-change="handleSelectionChange">

        <el-table-column type="selection" width="60">
        </el-table-column>

        <el-table-column label="工单号/内容" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-link class="link-class" :underline="false" @click="toDetail(scope.row.workorderid)">
              <div class="flex align-items-center">
                <div class="text-muted order-no">{{ scope.row.workorder_no}}</div>
                <icon-svg v-if="scope.row.type == 1" icon-class="maintask" style="font-size: 22px" />
                <icon-svg v-if="scope.row.type == 2" icon-class="subtask" style="font-size: 22px" />
              </div>
              <div class="ellipsis">{{ scope.row.workorder_title}}</div>
            </el-link>
          </template>
        </el-table-column>

        <el-table-column label="制号" prop="mfg_no" min-width="160" show-overflow-tooltip />

        <el-table-column label="派工数量" min-width="80" show-overflow-tooltip align="right">
          <template slot-scope="scope">
            <span class="font-16 number text-bold">{{ scope.row.plan_num }}</span>
            <span class="font-13 text-muted"> 件</span>
          </template>
        </el-table-column>

        <el-table-column label="派工工时" min-width="140" align="right">
          <template slot-scope="scope">
            <span class="font-16 number text-bold">{{ scope.row.plan_total_hour }} </span>
            <span class="font-13 text-muted">{{ scope.row.standard_unit }}</span>
          </template>
        </el-table-column>

        <el-table-column width="20" />

        <el-table-column label="工位" min-width="100">
          <template slot-scope="scope">
            <el-link class="link-class" :underline="false" @click="toWorkstationDetail(scope.row)">
              <span>{{ scope.row.station_title }}</span>
            </el-link>
          </template>
        </el-table-column>

        <el-table-column label="进度" align="center" min-width="320">
          <template slot-scope="scope">
            <div class="flex justify-content-space-between font-12">
              <span v-if="scope.row.status == 20" class="text-muted">计划开工</span>
              <span v-else>开工时间</span>

              <span v-if="scope.row.status == 20" class="text-blue">待开工</span>
              <span v-if="scope.row.status == 30" class="text-success">加工中</span>
              <span v-if="scope.row.status == 50" class="text-muted">已暂停</span>
              <span v-if="scope.row.status >= 80">已完工</span>

              <span v-if="scope.row.status < 80" class="text-muted">计划完工</span>
              <span v-else>完工时间</span>
            </div>
            <el-progress v-if="scope.row.status == 20" :percentage="5" :show-text="false" color="#409EFF"></el-progress>

            <el-progress v-if="scope.row.status == 30" :percentage="scope.row.percentage" :show-text="false">
            </el-progress>

            <el-progress v-if="scope.row.status == 50" :percentage="scope.row.percentage" :show-text="false"
              color="#999"></el-progress>

            <el-progress v-if="scope.row.status >= 80" :percentage="100" :show-text="false" color="#06793d">
            </el-progress>

            <div class="flex justify-content-space-between font-12">
              <span v-if="scope.row.status == 20" class="text-muted">{{ scope.row.plan_starttime |
              parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
              <span v-else>{{ scope.row.starttime | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>

              <span v-if="scope.row.status == 30" class="text-success">已用时 {{ scope.row.total_used }}</span>

              <span v-if="scope.row.status == 50">已用时 {{ scope.row.total_used }}</span>

              <span v-if="scope.row.status >= 80">共用时 {{ scope.row.total_used }}</span>

              <span v-if="scope.row.status == 20 || scope.row.status == 30 || scope.row.status == 50" class="text-muted"
                style="min-width:97px">{{ scope.row.plan_endtime | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
              <span v-if="scope.row.status >= 80">{{ scope.row.endtime | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column width="20" />

        <el-table-column label="操作员" min-width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.operator" class="flex align-items-center">
              <f-user-avatar :user="scope.row.operator"></f-user-avatar>
              <span class="ml-xs">{{scope.row.operator.username}}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="质检员" min-width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="!scope.row.schemeid && scope.row.endtime" class="text-muted">{{'无需质检'}}</div>
            <div v-if="scope.row.schemeid && scope.row.endtime && !scope.row.inspect_time" class="text-blue">{{'待质检'}}
            </div>
            <div v-if="scope.row.inspector" class="flex align-items-center">
              <f-user-avatar :user="scope.row.inspector"></f-user-avatar>
              <span class="ml-xs">{{scope.row.inspector.username}}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="进度监控" min-width="140">
          <template slot-scope="scope">
            <div v-if="scope.row.status_tip" class="flex align-items-center">
              <div class="round"
                :style="{ background: scope.row.status_tip.color, 'box-shadow': '0 0 5px' + scope.row.status_tip.color }" />
              <span class="ml-sm" :style="{ color: scope.row.status_tip.color}">{{scope.row.status_tip.content}}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="right" width="120">
          <template slot-scope="scope">
            <el-popover v-if="scope.row.status < 80" placement="left-start" width="120" trigger="click"
              popper-class="tool-pop" :visible-arrow="false">
              <div v-if="scope.row.status < 80" class="pop-item" role="button" @click="edit(scope.row)">编辑</div>
              <div v-if="scope.row.status < 80" class="pop-item" role="button" @click="clone(scope.row)">克隆</div>
              <div v-if="scope.row.status == 50" class="pop-item" role="button" @click="recover(scope.row)">恢复</div>
              <div v-if="scope.row.status == 30" class="pop-item" role="button" @click="suspend(scope.row)">暂停</div>
              <div v-if="scope.row.status < 80" class="pop-item" role="button" @click="end(scope.row)">终止</div>

              <i class="el-icon-more font-md ml-lg mr-sm" slot="reference" role="button"></i>
            </el-popover>


          </template>
        </el-table-column>

        <template slot="empty">
          <img class="image huger mt-lg" src="@/assets/empty.png">
          <div class="font-md mb-hg">暂无数据</div>
        </template>
      </el-table>
    </el-card>

    <f-table-footer checkbox :list="list" :selection="multiSelection" @toggle="toggleAll" :total="total"
      :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData">
      <template slot="left">
        <el-button plain :disabled="total === 0" size="mini" :loading="exporting" @click="exportM">导出</el-button>
      </template>
    </f-table-footer>
    <new-workorder v-if="dialogShow" :show.sync="dialogShow" :workorderid="activeWorkorderid" @success="fetchData()" />
    <clone-workorder
      v-if="cloneShow"
      :show.sync="cloneShow"
      :workorderid="cloneWorkorderid"
      @success="fetchData(1)"
    />
  </div>
</template>

<script>
import { getProgressApi, exportProgressApi } from "@/api/mes/progressApi";
import { workorderPauseApi, delMesWorkorderApi } from "@/api/mes/workorderApi";
import { second2String } from "@/utils/common";
import { getStationListApi } from "@/api/pp/stationApi";

export default {
  name: "MesProgress",

  components: {
    MesNumSelector: () => import("@/views/mes/components/MesNumSelector"),
    PpStationSelector: () => import("@/views/pp/components/PpStationSelector"),
    NewWorkorder: () => import("./components/NewWorkorder"),
    CloneWorkorder: () => import("./components/CloneWorkorder")
  },

  data() {
    return {
      dialogShow: false,
      activeWorkorderid: "",

      query: {
        keyword: "",
        status: 0,
        stationid: this.$route.query.stationid
          ? Number(this.$route.query.stationid)
          : null,
        mfgid: 0,
        dispatch_time: null,
        pindex: 1,
        psize: this.$store.state.commonStore.psize
      },
      total: 0,
      multiSelection: [],
      radios: [
        { value: 0, title: "全部进度", separate: true },
        { value: 1, title: "待开工" },
        { value: 2, title: "待完工" },
        { value: 3, title: "待质检" },
        { value: 4, title: "已生产" }
      ],
      steps: this.$store.state.mesStore.dispatchProcessArr,
      list: [],
      loading: false,

      query2: {
        keyword: "",
        pindex: 1,
        psize: this.$store.state.commonStore.psize
      },
      list2: [],
      total2: 0,
      loading2: false,
      cloneShow: false,

      exporting: false
    };
  },

  computed: {},

  created() {
    this.fetchData();
  },

  methods: {
    fetchData(page, loading = true) {
      if (page) this.query.pindex = page;
      if (loading) this.loading = true;
      getProgressApi(this.query).then(res => {
        this.loading = false;
        if (!res.errno) {
          const nowtime = parseInt(new Date().getTime() / 1000);
          this.list = res.data.list;
          this.list.forEach(item => {
            if (item.starttime && item.endtime && item.status >= 80) {
              item.total_used =
                item.endtime - item.starttime < 60
                  ? "0 min"
                  : second2String(item.endtime - item.starttime, false, true);
            }
            if (
              (item.starttime && !item.endtime) ||
              (item.starttime && item.status < 80)
            ) {
              item.total_used =
                nowtime - item.starttime < 60
                  ? "0 min"
                  : second2String(nowtime - item.starttime, false, true);
              item.percentage =
                ((nowtime - item.starttime) /
                  (item.plan_endtime - item.plan_starttime)) *
                  100 <
                100
                  ? ((nowtime - item.starttime) /
                      (item.plan_endtime - item.plan_starttime)) *
                    100
                  : 100;
              if (
                item.status == 30 ||
                (item.status == 50 && item.percentage >= 100)
              )
                item.percentage = 95;
            }
          });
          this.total = res.data.total;
        }
      });
    },

    toDetail(id) {
      this.$detail(id);
    },

    clone(row) {
      this.cloneWorkorderid = row ? row.workorderid : null;
      document.body.click();
      this.cloneShow = true;
    },

    fetchWorkstationData(page, loading = true) {
      if (page) this.query2.pindex = page;
      if (loading) this.loading2 = true;
      getStationListApi(this.query2).then(res => {
        this.loading2 = false;
        if (!res.errno) {
          this.list2 = res.data.list;
          this.list2.forEach(item => {
            item.binder = item.operators.concat(item.inspectors);
          });
          this.total2 = res.data.total;
        }
      });
    },

    toWorkstationDetail(row) {
      const { stationid } = row;
      const _this = this;
      this.$sdetail({
        stationid,
        handleChange: () => {
          _this.fetchWorkstationData();
        }
      });
    },

    handleSelectionChange(val) {
      this.multiSelection = val;
    },

    toggleAll() {
      this.$refs.listTable.toggleAllSelection();
    },

    exportM() {
      this.exporting = true;
      exportProgressApi(this.query)
        .then(res => {
          this.exporting = false;
          if (!res.errno) {
            window.open(res.data.url);
            this.$message.success("生产进度列表导出成功！");
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(err => {
          this.exporting = false;
        });
    },

    edit(row) {
      this.activeWorkorderid = row.workorderid;
      document.body.click();
      this.dialogShow = true;
    },

    recover(row) {
      document.body.click();
      this.$confirm(
        `即将恢复工单<span class="text-primary"> ${
          row.workorder_no
        }</span> 的生产，是否继续 ？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.loading = true;
          const temp = {
            workorderid: row.workorderid,
            is_pause: 0
          };
          workorderPauseApi(temp).then(res => {
            this.loading = false;
            if (!res.errno) {
              this.$message.success("工单恢复成功！");
              this.fetchData();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },

    suspend(row) {
      document.body.click();
      this.$confirm(
        `即将暂停工单<span class="text-primary"> ${
          row.workorder_no
        }</span> 的生产，是否继续 ？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.loading = true;
          const temp = {
            workorderid: row.workorderid,
            is_pause: 1
          };
          workorderPauseApi(temp).then(res => {
            this.loading = false;
            if (!res.errno) {
              this.$message.success("工单暂停成功！");
              this.fetchData();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },

    end(row) {
      document.body.click();
      this.$confirm(
        `即将终止工单<span class="text-primary"> ${
          row.workorder_no
        }</span> 的生产，是否继续 ？`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.loading = true;
          const temp = {
            workorderids: [row.workorderid],
            is_terminate: 1
          };
          delMesWorkorderApi(temp).then(res => {
            this.loading = false;
            if (!res.errno) {
              this.$message.success("工单终止成功！");
              this.fetchData();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.mes-progress {
  position: relative;

  .round {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .order-no:hover {
    color: #07c160;
  }

  .link-class {
    width: 100%;
    /deep/.el-link--inner {
      width: 100%;
    }
  }
}
</style>
